import {
    autocompleteFieldConstructor,
    dropdownFieldConfigConstructor, rangeFieldConfigConstructor,
    switchFieldConstructor,
    switchWithSelectFieldConstructor,
} from "scenes/cohort-filters/filter-configs/fieldContructors";
import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { switchWithYearSelectConstructor } from "scenes/cohort-filters/filter-configs/fieldContructors/switchWIthYearSelect";
import {nestedFieldConstructor} from "../../../filter-configs/fieldContructors/nestedField";

export const comorbidityFields = {
    ...switchWithSelectFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToSwitchQuestion: "anamnesis.haveCOVID",
        pathToSelectValue: "anamnesis.haveCOVIDTimesInfected",
        label: "anamnesis.comorbidity.haveCOVID",
        selectLabel: "anamnesis.comorbidity.haveCOVIDTimesInfectedLabel",
        selectOptions: [1, 2, 3, 4, 5].map((v) => ({ label: v, value: v })).concat({ label: "> 5", value: "GT5" }),
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToSwitchQuestion: "anamnesis.haveCOVIDVaccination",
        pathToSelectValue: "anamnesis.haveCOVIDVaccinationTimes",
        label: "anamnesis.comorbidity.haveCOVIDVaccination",
        selectLabel: "anamnesis.comorbidity.haveCOVIDVaccinationTimesQuestion",
        selectOptions: [1, 2, 3, 4, 5].map((v) => ({ label: v, value: v })).concat({ label: "> 5", value: "GT5" }),
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveAsthma",
        label: "anamnesis.comorbidity.asthma",
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveGastrointestinalBleeding",
        label: "anamnesis.comorbidity.haveGastrointestinalBleeding",
    }),
    ...switchWithSelectFieldConstructor({
        pathToSwitchQuestion: "anamnesis.haveMigraine",
        pathToSelectValue: "anamnesis.haveMigraineTimesPerMonth",
        label: "anamnesis.comorbidity.haveMigraine",
        category: Category.COMORBIDITIES,
        selectOptions: [
            {
                label: "< 3",
                value: "LT3",
            },
            {
                label: "3-5",
                value: "3-5",
            },
            {
                label: "> 5",
                value: "GT5",
            },
        ],
    }),
    ...switchWithSelectFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToSwitchQuestion: "anamnesis.haveDepression",
        pathToSelectValue: "anamnesis.haveDepressionType",
        label: "anamnesis.comorbidity.haveDepression",
        selectOptions: [
            { value: "TREATED_MEDICATION", label: "anamnesis.comorbidity.TREATED_MEDICATION" },
            { value: "TREATED_THERAPY", label: "anamnesis.comorbidity.TREATED_THERAPY" },
            { value: "UNTREATED", label: "anamnesis.comorbidity.UNTREATED" },
        ],
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveDepression",
        label: "anamnesis.comorbidity.dementia",
    }),
    ...switchWithYearSelectConstructor({
        category: Category.COMORBIDITIES,
        label: "anamnesis.comorbidity.haveThromboses",
        pathToYearValue: "anamnesis.haveThrombosesData.values.date",
        pathToSwitchQuestion: "anamnesis.haveThromboses",
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveCOPD",
        label: "anamnesis.comorbidity.haveCOPD",
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveOtherBleeding",
        label: "anamnesis.comorbidity.haveOtherBleeding",
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.haveRestlessLegsSyndrome",
        label: "anamnesis.comorbidity.haveRestlessLegsSyndrome",
    }),
    ...switchFieldConstructor({
        category: Category.COMORBIDITIES,
        pathToValue: "anamnesis.havePulmonaryHypertension",
        label: "anamnesis.comorbidity.havePulmonaryHypertension",
    }),
    ...nestedFieldConstructor({
        category: Category.COMORBIDITIES,
        label: "anamnesis.comorbidity.autoimmuneDisease",
        nestedPath: "$haveAutoimmuneDiseaseData$anamnesis.haveAutoimmuneDiseaseData.values",
        allowOrCondition: true,
        canExclude: true,
        nestedConfigs: [
            switchFieldConstructor({
                nestedComponent: true,
                pathToValue: "$nestedHaveAutoimmuneDisease$anamnesis.haveAutoimmuneDisease",
            }),
            autocompleteFieldConstructor({
                pathToValue: "anamnesis.haveAutoimmuneDiseaseData.values.disease",
                label: "anamnesis.comorbidity.whichDisease",
                fieldWidth: 150,
                nestedComponent: true,
            }),
            rangeFieldConfigConstructor({
                nestedComponent: true,
                pathToValue: "anamnesis.haveAutoimmuneDiseaseData.values.date",
                label: "Date",
                isDate: true,
                fieldWidth: 100,
            }),
            dropdownFieldConfigConstructor({
                pathToValue: "anamnesis.haveAutoimmuneDiseaseData.values.treatment",
                label: "anamnesis.comorbidity.treatment",
                nestedComponent: true,
                dropdownValues: Object.freeze([
                    {value: "CORTISON", label: "anamnesis.comorbidity.CORTISON"},
                    {value: "IBUPROFEN", label: "anamnesis.comorbidity.IBUPROFEN"},
                    {value: "DICLOFENAC", label: "anamnesis.comorbidity.DICLOFENAC"},
                    {value: "ANTIKÖRPERTHERAPIE", label: "anamnesis.comorbidity.ANTIKÖRPERTHERAPIE"},
                    {value: "CHEMOTHERAPIE_METHOTREXATE", label: "anamnesis.comorbidity.CHEMOTHERAPIE_METHOTREXATE"},
                ]),
                fieldWidth: 150,
            }),
        ],
    }),
};
